import React, { useState } from "react";
import { FiSend, FiUser, FiMail, FiPhone, FiTag, FiMessageSquare } from "react-icons/fi";
import { apiRequest, errorMessage } from "../api";
import { Field, FormAlert, FormCard, SubmitButton, SuccessPanel } from "./forms/formKit";

const empty = { name: "", email: "", phone: "", subject: "", message: "", website: "" };

// The Contact page's message form. Submissions are stored in the database and read in the admin
// panel under Contact > Messages. "website" is a hidden trap field for spam bots.
export default function ContactForm() {
  const [form, setForm] = useState(empty);
  const [status, setStatus] = useState("idle");   // idle | sending | sent
  const [error, setError] = useState("");

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    const { ok, data } = await apiRequest("/core/contact-messages/", { method: "POST", body: form });
    if (!ok) {
      setStatus("idle");
      return setError(errorMessage(data));
    }
    setForm(empty);
    setStatus("sent");
  };

  return (
    <section id="contact-form" className="relative bg-navy-dark text-white py-14 md:py-20 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-10">
          <span className="text-accent-light uppercase tracking-widest text-sm font-semibold">Contact Us</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight">Send us a message</h2>
          <p className="mt-3 text-gray-400">Tell us about your project or question and we will get back to you soon.</p>
        </div>

        <FormCard title="Your details" subtitle="Fields marked * are needed. We never share your details." icon={FiMessageSquare}>
          {status === "sent" ? (
            <SuccessPanel title="Thank you!" action="Send another message" onAction={() => setStatus("idle")}>
              Your message has been received. We will reply by email as soon as possible.
            </SuccessPanel>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div className="grid md:grid-cols-2 gap-5">
                <Field label="Your name" required icon={FiUser} maxLength={150} placeholder="e.g. Ali Khan" autoComplete="name" value={form.name} onChange={set("name")} />
                <Field label="Email address" required icon={FiMail} type="email" placeholder="you@example.com" autoComplete="email" value={form.email} onChange={set("email")} />
                <Field label="Phone" icon={FiPhone} maxLength={40} placeholder="Optional, with country code" autoComplete="tel" value={form.phone} onChange={set("phone")} />
                <Field label="Subject" icon={FiTag} maxLength={200} placeholder="What is it about?" value={form.subject} onChange={set("subject")} />
              </div>
              <Field as="textarea" label="Your message" required icon={FiMessageSquare} rows={6} placeholder="Tell us about your project, budget and timeline..." value={form.message} onChange={set("message")} />

              {/* Spam trap: invisible to people, filled in by bots */}
              <input tabIndex={-1} autoComplete="off" aria-hidden="true" name="website" value={form.website} onChange={set("website")} className="hidden" />

              <FormAlert>{error}</FormAlert>

              <SubmitButton busy={status === "sending"} icon={FiSend} className="w-full md:w-auto">Send Message</SubmitButton>
            </form>
          )}
        </FormCard>
      </div>
    </section>
  );
}
